"use client";

import { useRef } from "react";
import { useResourceNav, type NavOption } from "./resource-nav";
import css from "./resource.module.scss";

export const ResourceTableOfContents = ({
  options,
}: {
  options: NavOption[];
}) => {
  const { currentSection, onSelect, setOptions } = useResourceNav();
  const ref = useRef<HTMLUListElement>(null);
  const refObserver = useRef<IntersectionObserver>(null);

  const handleRef = (node: HTMLUListElement) => {
    if (node) {
      ref.current = node;
      if (refObserver.current) {
        refObserver.current.disconnect();
      }

      refObserver.current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const header = document.getElementById("header");

            if (header) {
              setOptions({
                offsetElement: header,
                additionalOffset: header.offsetHeight * 0.2,
              });
            }
          }
        });
      });

      refObserver.current.observe(node);
    }
  };

  return (
    <ul ref={handleRef} className={css.resourceTableOfContentsList}>
      {options.map((option) => {
        const isExcerpt = option.value === "excerpt";
        const isHeading =
          option.value !== "excerpt" &&
          option.value !== "key-takeaways" &&
          option.value !== "faq";
        const isActive = currentSection === option.value;

        return (
          <li
            key={option.value}
            className={css.resourceTableOfContentsListItem}
            style={isHeading ? { position: "relative" } : undefined}
          >
            <button
              type="button"
              onClick={() => onSelect(option.value)}
              className="text-left"
            >
              {isActive && (
                <span
                  className={
                    isExcerpt
                      ? "absolute left-[-24px] top-1/2 h-full w-2 -translate-y-1/2 transform bg-[#069590]"
                      : "absolute left-[-16px] top-0 h-full w-2 bg-[#069590]"
                  }
                />
              )}
              <span>{option.label}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ResourceTableOfContents;
